<template>
    <div>
        <div class="field grid">
            <div class="col-12 md:col-3">
                <span class="text-900 font-medium">Status Dokumen Pengadaan</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import Button from 'primevue/button';
    export default defineComponent({
        components: {
            Button,
        },
        props: {
            type: {
                type: String,
                default: 'submit',
            },
        }
    })
</script>
